// extracted by mini-css-extract-plugin
export default {"favBtn":"AdminMobileSaleStatusList_favBtn__bjYn9","favIcon":"AdminMobileSaleStatusList_favIcon__ZDquJ","favorite":"AdminMobileSaleStatusList_favorite__DbPHD"};